import { IRectangle, List } from '@fluentui/react';
import { ShortPaymentModel } from '../../models/PaymentModels';
import PaymentItemView from './PaymentItemView';

type PaymentGridProps = {
    invoices: ShortPaymentModel[];
    onDetail: (order: ShortPaymentModel) => void;
}

export default function PaymentGridView({ invoices, onDetail }: PaymentGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return invoices.length;
    }

    const onRenderCell = (payment?: ShortPaymentModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (payment == null) return <>empty</>;

        return <div
            key={payment.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <PaymentItemView key={payment.id} payment={payment} onDetail={onDetail} />
        </div>;
    }

    return <div style={{ marginLeft: -20, marginRight: -20 }}>
        <List
            items={invoices}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}